module.exports = __webpack_public_path__ + "static/media/sendbutton.dcd014fa.svg";